// extracted by mini-css-extract-plugin
export default {"footer":"HQEditModal_footer__vwvbv","cancel_btn":"HQEditModal_cancel_btn__wwkiC"};